var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/offer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/offer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.03098724,14.3475073 L9.58638298,18.532108 C10.1200961,18.8277082 10.7595467,18.8635303 11.3229359,18.6293899 L22.0445596,14.1735628 C22.6230313,13.9331542 23,13.3682617 23,12.7418227 L23,12.3601088 C23,11.9358268 22.8650709,11.5225375 22.6147192,11.1799894 L22.5170765,11.046388 C22.213569,10.6311086 21.7300886,10.3856193 21.2157213,10.3856193 L18.3095771,10.3856193 C17.7558314,10.3856193 17.3069318,10.8345189 17.3069318,11.3882647 C17.3069318,12.0011242 16.9555981,12.5597225 16.4031968,12.825146 L15.7131829,13.156691 C15.4428978,13.2865604 15.1468691,13.3539899 14.8470023,13.3539899 L9.52654459,13.3539899 C8.9540968,13.3539899 8.49003618,12.8899293 8.49003618,12.3174815 C8.49003618,11.7450337 8.9540968,11.2809731 9.52654459,11.2809731 L14.5509957,11.2809731 C14.9660749,11.2809731 15.302563,10.944485 15.302563,10.5294058 C15.302563,10.0531354 15.0912226,9.60141959 14.7255986,9.29621059 L13.7268226,8.46247048 C13.3672006,8.16227174 12.9136118,7.99783379 12.4451598,7.99783379 L8.08630612,7.99783379 C7.54208835,7.99783379 7.02137071,7.77605918 6.64427262,7.38366905 L5.90475706,6.61416474 C5.52765897,6.22177461 5.00694132,6 4.46272355,6 L3,6 C1.8954305,6 1,6.8954305 1,8 L1,12.5979318 C1,13.3251969 1.39478467,13.9951427 2.03098724,14.3475073 Z",
    id: "Path-5",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.0654843630d471bcf59db81cbd9d89e1.svg";
export { ForwardRef as ReactComponent };